import { render, staticRenderFns } from "./terms-conditions.vue?vue&type=template&id=329b2146&"
import script from "./terms-conditions.vue?vue&type=script&lang=ts&"
export * from "./terms-conditions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports